<template>
    <h4 class="mt-6 font-semibold tracking-wide text-base-2 leading-tighter md:mt-8 md:mt-5 tech-title"
        :class=" type === 'rent' ? 'text-gray-950':'text-blue-800'"
    >
        Объявления {{ type === 'rent' ? 'аренды':'продажи' }} ({{ currentLocal }}/{{ max }})
    </h4>

</template>

<script>
export default {
    name: "PayloadsCounter",
    props: {
        type: {
            type: String,
            default: 'rent',
            validator: (val) => ['rent','sale'].includes(val)
        },
        current: {
            type: Number,
            required: true
        },
        max: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            currentLocal: this.current
        }
    },
    mounted() {

        if (this.type === 'rent'){
             this.$root.$on('count-of-rent-payloads-changed', (msg) => {
                 if (msg===true) {
                     this.currentLocal++;
                     return;
                 }
                 this.currentLocal--;
             })
        } else {
            this.$root.$on('count-of-sale-payloads-changed', (msg) => {
                if (msg===true) {
                     this.currentLocal++;
                     return;
                 }
                 this.currentLocal--;
             })
        }

         console.log('ItemsCounter mounted');
    }
}


</script>

<style scoped>

</style>
